/* ==========================================================================
   Carousel
   ========================================================================== */

/* Modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const carouselPrototype = require('./prototype');
const config = require('./config');

/**
 * Client/browser JS
 * @param {string} selector String selector
 * @param {object} config Configuration object to create the carousel instance
 */
module.exports = function CarouselClient(selector = '[data-component="Carousel"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Create the instance based on prototype */
        const instance = Object.create(carouselPrototype);

        /* Element reference */
        instance.element = document.querySelector(selector);

        /* Id reference */
        instance.id = instance.element.dataset.id || randomId('carousel');

        /* Config */
        instance.config = {
            ...config(),
            ...configuration,
            swiper: { ...config().swiper, ...configuration.swiper, lazy: false }
        };

        /* Set pagination based on data model */
        if (Object.keys(instance.element.dataset).filter(item => item === 'pagination').length > 0) {
            instance.config.hasPagination = true;
        } else {
            instance.config.hasPagination = false;
        }

        /* Set navigation based on data model */
        if (Object.keys(instance.element.dataset).filter(item => item === 'navigation').length > 0) {
            instance.config.hasNavigation = true;
        } else {
            instance.config.hasNavigation = false;
        }

        /* Auto init */
        if (instance.config.init) instance.init();

        return instance;
    }
};
